module.exports = __webpack_public_path__ + "img/Products_Desktop_02.5aa6a0d8.jpg";